
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minebitcoin",
      function () {
        return require("private-next-pages/minebitcoin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minebitcoin"])
      });
    }
  